import React, { forwardRef, Ref, SVGProps } from 'react'

const _IconChecklistEmpty = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" {...props} ref={ref}>
    <circle cx="8.33334" cy="8" r="7.25" fill="currentColor" stroke="#C0C9CE" strokeWidth="1.5" />
  </svg>
)

export const IconChecklistEmpty = forwardRef(_IconChecklistEmpty)
